{
  "version": "1.0.0",
  "id": "at.softline.holzbraun.softline",
  "name": "Softline"
}
